import React from "react";

export const RightArrow = (): JSX.Element => (
  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.864777 9.7075L4.98946 5.5L0.864777 1.2925L2.1346 0L7.53811 5.5L2.1346 11L0.864777 9.7075Z" fill="white"/>
  </svg>
);
